import { render, staticRenderFns } from "./CallCenterManagersList.vue?vue&type=template&id=21cf141e&scoped=true&"
import script from "./CallCenterManagersList.vue?vue&type=script&lang=js&"
export * from "./CallCenterManagersList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21cf141e",
  null
  
)

export default component.exports